import { ExportFile } from '../types/export/export';
import {
  CreateProductMasterDataExportConfigurationInput,
  DeleteProductMasterDataExportConfigurationInput,
  ProductMasterDataExportConfiguration,
  UpdateProductMasterDataExportConfigurationInput,
} from '../types/product_master_data_export_configuration';
import { http } from '../util/https.util';
import { PaginatedResponse } from './common/paginatedResponse';

const EXPORT = '/api/product_master_data/export';
const CONFIGURATIONS = '/api/product_master_data/export/list';
const CREATE_CONFIGURATION = '/api/product_master_data/export/create';
const UPDATE_CONFIGURATION = '/api/product_master_data/export/update';
const DELETE_CONFIGURATION = '/api/product_master_data/export/delete';

export namespace ProductMasterDataExportConfigurationRequest {
  export interface ProductExportPayload {
    configId?: string;
    timezone?: string;
    locale?: string;
  }

  export const download = async (payload: ProductExportPayload): Promise<ExportFile> => {
    return (await http.post(EXPORT, payload)).data;
  };

  export const list = async (payload: {
    page: number;
  }): Promise<PaginatedResponse<ProductMasterDataExportConfiguration>> => {
    return (await http.post(CONFIGURATIONS, payload)).data;
  };

  export const create = async (payload: {
    data: CreateProductMasterDataExportConfigurationInput[];
  }): Promise<ProductMasterDataExportConfiguration[]> => {
    return (await http.post(CREATE_CONFIGURATION, payload)).data;
  };

  export const update = async (payload: {
    data: UpdateProductMasterDataExportConfigurationInput[];
  }): Promise<ProductMasterDataExportConfiguration[]> => {
    return (await http.post(UPDATE_CONFIGURATION, payload)).data;
  };

  export const remove = async (payload: {
    data: DeleteProductMasterDataExportConfigurationInput[];
  }): Promise<ProductMasterDataExportConfiguration[]> => {
    return (await http.post(DELETE_CONFIGURATION, payload)).data;
  };
}
